export const FILTER_GROUP_TEAM_SIZE = 'team_size';
export const FILTER_GROUP_KPI = 'kpi';
export const FILTER_GROUP_SCORE = 'score';
